import React from 'react';
import ModuleDetailPage from './ModuleDetailPage';

const OnlineOrderPage = () => <ModuleDetailPage moduleId="online-order" />;

export default OnlineOrderPage;
